// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"b731584c","38":"fe88ee63","777":"edaa8c1c"}[chunkId] + ".chunk.js";
};